import {LocalStorage} from "./LocalStorage";

export class User implements UserInterface {
    private storage: LocalStorage = new LocalStorage();
    private static _data: UserInterface | null = null;
    private static _token: string | any = null;

    set(user: UserInterface | null, token: string | any): void {
        if (!user?.version || !token) {
            return;
        }
        this.storage.setEncoded('user', User._data = user, this.storage.getSessionId());
        this.storage.setEncoded('user.token', token, user.version);
    }

    init() {
        try {
            User._data = this.storage.getDecoded('user', this.storage.getSessionId());
            User._token = this.storage.getDecoded('user.token', this.version);
        } catch (e) {
            this.storage.remove('user');
            this.storage.remove('user.token');
        }
    }

    hasRight(right: string) {
        if (this.rights === null) {
            return false;
        }
        return this.rights.includes(right);
    }

    get name(): string | any {
        return User._data?.name || null;
    }

    get email(): string | any {
        return User._data?.email || null;
    }

    get version(): string | any {
        return User._data?.version || null;
    }

    get rights(): string[] | any {
        return User._data?.rights || null;
    }

    getToken(): string | any {
        return User._token || null;
    }

    valid(): boolean {
        if (this.getToken() === null || this.version === null) {
            return false;
        }
        return 0 < this.expireAt;
    }

    get expireAt(): number {
        return this.exp - Math.floor(Date.now() / 1000);
    }

    get iss(): string | any {
        return User._data?.iss || null;
    }

    get iat(): number | any {
        return User._data?.iat || null;
    }

    get nbf(): number | any {
        return User._data?.nbf || null;
    }

    get exp(): number | any {
        return User._data?.exp || null;
    }

    needRenew(checkUserVersion: any): boolean {
        if (typeof checkUserVersion !== 'undefined' && this.version !== checkUserVersion) {
            return true;
        }
        return this.valid() && this.expireAt < 900;
    }
}

export interface UserInterface {
    needRenew(checkUserVersion: any): boolean;

    valid(): boolean;

    iss: string;
    iat: number;
    nbf: number;
    exp: number;
    name: string;
    email: string;
    version: string | null;
    rights: string[];

    getToken(): string | any;

    set(
        user: UserInterface | any,
        token: string | any
    ): void;
}